/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.chart[_ngcontent-%COMP%]   .line[_ngcontent-%COMP%]{margin-top:20px}canvas[_ngcontent-%COMP%]{height:175px}@media (min-width:576px){canvas[_ngcontent-%COMP%]{height:280px}}@media (min-width:992px){canvas[_ngcontent-%COMP%]{height:267px}}"];
export { styles as styles };
